import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import mockData from '../mock';

const Footer = () => {
  const { brand } = mockData;

  return (
    <footer className="bg-gradient-to-br from-blue-900 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-4 bg-white rounded-lg p-3 inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_zeropower/artifacts/hsn059yp_NEW%20STYLE.jpg" 
                alt="Bijaya Solar - Registered Vendor for PM Surya Ghar Yojana"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              Odisha's most trusted solar energy provider. Helping families save money and protect the environment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#subsidy" className="text-blue-200 hover:text-orange-400 transition-colors">
                  Subsidy Calculator
                </a>
              </li>
              <li>
                <a href="#why-us" className="text-blue-200 hover:text-orange-400 transition-colors">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-blue-200 hover:text-orange-400 transition-colors">
                  Customer Reviews
                </a>
              </li>
              <li>
                <a href="#process" className="text-blue-200 hover:text-orange-400 transition-colors">
                  Installation Process
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-blue-200">
              <li>Rooftop Solar Installation</li>
              <li>Subsidy Application</li>
              <li>Net Metering Setup</li>
              <li>Maintenance & Support</li>
              <li>System Upgrades</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-orange-400 flex-shrink-0 mt-1" />
                <span className="text-blue-200 text-sm">{brand.location}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-orange-400 flex-shrink-0" />
                <a href={`tel:${brand.phone}`} className="text-blue-200 hover:text-orange-400 transition-colors">
                  {brand.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-orange-400 flex-shrink-0" />
                <a href={`mailto:${brand.email}`} className="text-blue-200 hover:text-orange-400 transition-colors">
                  {brand.email}
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex items-center space-x-4 mt-6">
              <a 
                href="https://www.facebook.com/bijaysolar.co" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/bijayasolar?igsh=MTVsY2NsYWYycHJqZA%3D%3D&utm_source=qr" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-blue-300 text-sm">
            © 2025 {brand.name}. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-blue-300 hover:text-orange-400 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-blue-300 hover:text-orange-400 text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;